// import React, {
//   useState,
//   useLayoutEffect,
//   useRef,
//   useEffect,
//   useCallback,
// } from "react";
// import debounce from "lodash/debounce";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useAuth } from "../contexts/AuthContext";
// import { useCart } from "../contexts/CartContext";
// import LogoutButton from "./LogoutButton";
// import ImageFile from "../images/afrogebeya.png";
// import "../styles/header.css";

// function Header({ hideExtras = false }) {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [showUserMenu, setShowUserMenu] = useState(false);
//   const [activeIndex, setActiveIndex] = useState(-1);

//   const dropdownRef = useRef(null);
//   const buttonRef = useRef(null);
//   const hideTimerRef = useRef(null);
//   const searchWrapperRef = useRef(null);

//   const { auth, isAuthenticated } = useAuth();
//   const { cartCount } = useCart();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [showSuggestions, setShowSuggestions] = useState(false);
//   const wrapperRef = useRef(null);

//   const displayName = auth?.firstName ?? "User";

//   const pathSegment = location.pathname.split("/")[1]?.toLowerCase();
//   const prefix = pathSegment === "seller" ? "/seller" : "/buyer";

//   const hideExtrasOnPath =
//     location.pathname.startsWith("/seller") ||
//     location.pathname.startsWith("/admin");

//   const fetchSuggestions = useCallback(
//     debounce(async (value) => {
//       if (!value.trim()) {
//         setSuggestions([]);
//         return;
//       }

//       try {
//         const res = await fetch(
//           `${process.env.REACT_APP_PRODUCT_SERVICE_URL}/products/search/suggestions?q=${value}`,
//         );

//         if (res.ok) {
//           const data = await res.json();
//           setSuggestions(data);
//         }
//       } catch (err) {
//         console.error("Suggestion error:", err);
//       }
//     }, 300),
//     [],
//   );

//   useEffect(() => {
//     fetchSuggestions(searchTerm);
//   }, [searchTerm, fetchSuggestions]);

//   // Close suggestion if clicked outside
//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
//         setShowSuggestions(false);
//       }
//     }
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useLayoutEffect(() => {
//     const header = document.querySelector(".navbar-custom");
//     const main = document.querySelector("#main-content");

//     if (header && main) {
//       main.style.paddingTop = `${header.offsetHeight}px`;
//     }
//   }, []);

//   const handleSearch = (e) => {
//     e.preventDefault();

//     if (activeIndex >= 0) {
//       navigate(`/products/${suggestions[activeIndex].id}`);
//     } else {
//       navigate(`/search?q=${searchTerm}`);
//     }

//     setSuggestions([]);
//   };

//   const handleKeyDown = (e) => {
//     if (!suggestions.length) return;

//     if (e.key === "ArrowDown") {
//       e.preventDefault();
//       setActiveIndex((prev) => (prev + 1) % suggestions.length);
//     }

//     if (e.key === "ArrowUp") {
//       e.preventDefault();
//       setActiveIndex((prev) => (prev <= 0 ? suggestions.length - 1 : prev - 1));
//     }

//     if (e.key === "Enter" && activeIndex >= 0) {
//       navigate(`/products/${suggestions[activeIndex].id}`);
//       setSuggestions([]);
//     }

//     if (e.key === "Escape") {
//       setSuggestions([]);
//     }
//   };

//   const closeMenu = () => {
//     clearTimeout(hideTimerRef.current);
//     setShowUserMenu(false);
//   };

//   const startAutoClose = () => {
//     clearTimeout(hideTimerRef.current);
//     hideTimerRef.current = setTimeout(closeMenu, 3000);
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (
//         searchWrapperRef.current &&
//         !searchWrapperRef.current.contains(e.target)
//       ) {
//         setSuggestions([]);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <nav className="navbar navbar-dark navbar-custom fixed-top shadow-sm px-3">
//       <div className="container-fluid header-container">
//         {/* LOGO */}
//         <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
//           <img src={ImageFile} alt="Afrogebeya" height="38" />
//           <strong>Afrogebeya</strong>
//         </Link>

//         {/* SEARCH */}
//         {!hideExtras && !hideExtrasOnPath && (
//           <div ref={searchWrapperRef} className="search-wrapper">
//             <form onSubmit={handleSearch} className="search-form">
//               <input
//                 type="search"
//                 placeholder="Search products..."
//                 value={searchTerm}
//                 onChange={(e) => {
//                   setSearchTerm(e.target.value);
//                   setActiveIndex(-1);
//                 }}
//                 onKeyDown={handleKeyDown}
//                 autoComplete="off"
//                 className="search-input"
//               />

//               <button className="search-btn">
//                 <i className="bi bi-search"></i>
//               </button>
//             </form>

//             {suggestions.length > 0 && (
//               <div className="suggestion-dropdown">
//                 {suggestions.map((item, index) => (
//                   <div
//                     key={item.id}
//                     className={`suggestion-item ${
//                       index === activeIndex ? "active" : ""
//                     }`}
//                     onClick={() => {
//                       navigate(`/products/${item.id}`);
//                       setSuggestions([]);
//                     }}
//                   >
//                     <div className="fw-semibold">{item.productName}</div>
//                     <div className="small text-muted">{item.price} ETB</div>
//                   </div>
//                 ))}

//                 <div
//                   className="suggestion-view-all"
//                   onClick={() => {
//                     navigate(`/search?q=${searchTerm}`);
//                     setSuggestions([]);
//                   }}
//                 >
//                   View all results →
//                 </div>
//               </div>
//             )}
//           </div>
//         )}

//         {/* RIGHT ACTIONS */}
//         {!hideExtras && (
//           <div className="header-actions">
//             <Link to="/cart" className="cart-btn">
//               🛒
//               {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
//             </Link>

//             {isAuthenticated ? (
//               <div className="user-menu-wrapper">
//                 <button
//                   ref={buttonRef}
//                   className="user-btn"
//                   onClick={() => {
//                     setShowUserMenu((v) => !v);
//                     startAutoClose();
//                   }}
//                 >
//                   👤 {displayName}
//                 </button>

//                 <div
//                   ref={dropdownRef}
//                   className={`user-dropdown ${showUserMenu ? "open" : ""}`}
//                   onMouseEnter={() => clearTimeout(hideTimerRef.current)}
//                   onMouseLeave={startAutoClose}
//                 >
//                   <Link to={`${prefix}/notifications`} onClick={closeMenu}>
//                     🔔 Notifications
//                   </Link>

//                   <Link to={`${prefix}/profile`} onClick={closeMenu}>
//                     👤 Profile
//                   </Link>

//                   <Link to={`${prefix}/settings`} onClick={closeMenu}>
//                     ⚙️ Settings
//                   </Link>

//                   <hr />

//                   <LogoutButton closeMenu={closeMenu} />
//                 </div>
//               </div>
//             ) : (
//               <>
//                 <Link to="/login" className="auth-btn">
//                   Login
//                 </Link>
//                 <Link to="/register" className="auth-btn">
//                   Register
//                 </Link>
//               </>
//             )}
//           </div>
//         )}
//       </div>
//     </nav>
//   );
// }

// export default Header;

import React, {
  useState,
  useLayoutEffect,
  useRef,
  useEffect,
  useCallback,
} from "react";
import debounce from "lodash/debounce";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useCart } from "../contexts/CartContext";
import LogoutButton from "./LogoutButton";
import ImageFile from "../images/afrogebeya.png";
import "../styles/header.css";

function Header({ hideExtras = false }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  const hideTimerRef = useRef(null);
  const searchWrapperRef = useRef(null);

  const { auth, isAuthenticated } = useAuth();
  const { cartCount } = useCart();
  const navigate = useNavigate();
  const location = useLocation();

  const displayName = auth?.firstName ?? "User";

  const hideExtrasOnPath =
    location.pathname.startsWith("/seller") ||
    location.pathname.startsWith("/admin");

  /* ---------------- SEARCH SUGGESTIONS ---------------- */

  const fetchSuggestions = useCallback(
    debounce(async (value) => {
      if (!value.trim()) {
        setSuggestions([]);
        return;
      }

      try {
        const res = await fetch(
          `${process.env.REACT_APP_PRODUCT_SERVICE_URL}/products/search/suggestions?q=${value}`,
        );

        if (res.ok) {
          const data = await res.json();
          setSuggestions(data);
        }
      } catch (err) {
        console.error("Suggestion error:", err);
      }
    }, 300),
    [],
  );

  useEffect(() => {
    fetchSuggestions(searchTerm);
  }, [searchTerm, fetchSuggestions]);

  /* ---------------- CLOSE SUGGESTIONS ON OUTSIDE CLICK ---------------- */

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchWrapperRef.current &&
        !searchWrapperRef.current.contains(e.target)
      ) {
        setSuggestions([]);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  /* ---------------- FIX CONTENT OFFSET ---------------- */

  useLayoutEffect(() => {
    const header = document.querySelector(".navbar-custom");
    const main = document.querySelector("#main-content");

    if (header && main) {
      main.style.paddingTop = `${header.offsetHeight}px`;
    }
  }, []);

  /* ---------------- SEARCH SUBMIT ---------------- */

  const handleSearch = (e) => {
    e.preventDefault();

    if (activeIndex >= 0) {
      navigate(`/products/${suggestions[activeIndex].id}`);
    } else {
      navigate(`/search?q=${searchTerm}`);
    }

    setSuggestions([]);
  };

  /* ---------------- KEYBOARD NAVIGATION ---------------- */

  const handleKeyDown = (e) => {
    if (!suggestions.length) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) => (prev + 1) % suggestions.length);
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) => (prev <= 0 ? suggestions.length - 1 : prev - 1));
    }

    if (e.key === "Enter" && activeIndex >= 0) {
      navigate(`/products/${suggestions[activeIndex].id}`);
      setSuggestions([]);
    }

    if (e.key === "Escape") {
      setSuggestions([]);
    }
  };

  /* ---------------- USER MENU ---------------- */

  const closeMenu = () => {
    clearTimeout(hideTimerRef.current);
    setShowUserMenu(false);
  };

  const startAutoClose = () => {
    clearTimeout(hideTimerRef.current);
    hideTimerRef.current = setTimeout(closeMenu, 3000);
  };

  /* ---------------- UI ---------------- */

  return (
    <nav className="navbar navbar-dark navbar-custom fixed-top shadow-sm px-3">
      <div className="container-fluid header-container">
        {/* LOGO */}
        <Link to="/" className="navbar-brand d-flex align-items-center gap-2">
          <img src={ImageFile} alt="Afrogebeya" height="38" />
          <strong>Afrogebeya</strong>
        </Link>

        {/* SEARCH */}
        {!hideExtras && !hideExtrasOnPath && (
          <div ref={searchWrapperRef} className="search-wrapper">
            <form onSubmit={handleSearch} className="search-form">
              <input
                type="search"
                placeholder="Search products..."
                value={searchTerm}
                autoComplete="off"
                className="search-input"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setActiveIndex(-1);
                }}
                onKeyDown={handleKeyDown}
              />

              <button className="search-btn">
                <i className="bi bi-search"></i>
              </button>
            </form>

            {suggestions.length > 0 && (
              <div className="suggestion-dropdown">
                {suggestions.map((item, index) => (
                  <div
                    key={item.id}
                    className={`suggestion-item ${
                      index === activeIndex ? "active" : ""
                    }`}
                    onClick={() => {
                      navigate(`/products/${item.id}`);
                      setSuggestions([]);
                    }}
                  >
                    <div className="fw-semibold">{item.productName}</div>
                    <div className="small text-muted">{item.price} ETB</div>
                  </div>
                ))}

                <div
                  className="suggestion-view-all"
                  onClick={() => {
                    navigate(`/search?q=${searchTerm}`);
                    setSuggestions([]);
                  }}
                >
                  View all results →
                </div>
              </div>
            )}
          </div>
        )}

        {/* RIGHT ACTIONS */}
        {!hideExtras && (
          <div className="header-actions">
            {/* CART */}
            <Link to="/cart" className="cart-btn">
              <i className="bi bi-cart"></i>
              {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
            </Link>

            {/* AUTH */}
            {isAuthenticated ? (
              <div className="user-menu-wrapper">
                <button
                  ref={buttonRef}
                  className="user-btn"
                  onClick={() => {
                    setShowUserMenu((v) => !v);
                    startAutoClose();
                  }}
                >
                  <i className="bi bi-person-circle"></i> {displayName}
                </button>

                <div
                  ref={dropdownRef}
                  className={`user-dropdown ${showUserMenu ? "open" : ""}`}
                  onMouseEnter={() => clearTimeout(hideTimerRef.current)}
                  onMouseLeave={startAutoClose}
                >
                  <Link to="buyer/profile" onClick={closeMenu}>
                    Profile
                  </Link>

                  <Link to="buyer/settings" onClick={closeMenu}>
                    Settings
                  </Link>

                  <hr />

                  <LogoutButton closeMenu={closeMenu} />
                </div>
              </div>
            ) : (
              <>
                <Link to="/login" className="auth-btn">
                  Login
                </Link>

                <Link to="/register" className="auth-btn">
                  Register
                </Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}

export default Header;
